import { motion } from "framer-motion";
import { DIFFS } from "../lib/content";
import { Reveal, Eyebrow, MaskLines, EASE } from "./Reveal";
import { LogoSquare } from "./JLMark";

export const WhyUs = () => (
  <section id="solucoes" data-testid="why-section" className="relative overflow-hidden border-t border-white/5 bg-[#0A0E16] py-24 sm:py-32">
    <div className="grid-lines pointer-events-none absolute inset-0 opacity-60" />
    <div className="relative mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal><Eyebrow>02 — Por que escolher a JL Nexus?</Eyebrow></Reveal>
          <h2 className="font-display mt-6 text-3xl font-semibold leading-[1.06] tracking-tight sm:text-[2.75rem]">
            <MaskLines inView lines={[<>Seu negócio não precisa</>, <>de qualquer site.</>, <span className="text-grad">Precisa de uma presença</span>, <span className="text-grad">digital estratégica.</span>]} />
          </h2>
          <Reveal delay={0.3}>
            <div className="relative mt-12 hidden items-center justify-center overflow-hidden rounded-3xl border border-white/10 bg-[#080B12] sm:flex">
              <div className="animated-gradient absolute h-24 w-24 rounded-full opacity-40 blur-2xl" />
              <LogoSquare className="relative h-44 w-44 drop-shadow-[0_0_35px_rgba(8,123,255,0.55)]" alt="Logotipo oficial JL Nexus" />
              <span className="font-mono-jl absolute bottom-4 left-5 text-[11px] uppercase tracking-[0.3em] text-slate-400">Estratégia • Design • Código</span>
            </div>
          </Reveal>
        </div>
      </div>
      <ul className="grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:col-span-7">
        {DIFFS.map((d, i) => (
          <motion.li
            key={d.title}
            data-testid={`diff-item-${i}`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.1, ease: EASE }}
            className="group relative bg-[#0C1019] p-7 transition-colors duration-500 hover:bg-[#111827] sm:p-8"
          >
            <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-gradient-to-r from-[#087BFF] to-[#00C8FF] transition-transform duration-700 group-hover:scale-x-100" />
            <div className="flex items-center justify-between">
              <d.icon className="h-7 w-7 text-[#00C8FF] transition-transform duration-500 group-hover:-translate-y-1 group-hover:scale-110" />
              <span className="font-mono-jl text-xs text-slate-400">/{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="font-display mt-8 text-lg font-semibold text-white sm:text-xl">{d.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">{d.text}</p>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
